import { SerializedData, Store } from "bernie-core";
import { Logger } from "bernie-logger";
import { ThumborStore } from "./ThumborStore";

export class ClientThumborStore extends Store implements ThumborStore {
  private thumborizedImageUrlMap: { [key: string]: string } = {};

  public constructor(state: SerializedData, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public safelyGenerateThumborizedImageUrl = (
    imageUrl: string,
    width?: number,
    height?: number
  ) => {
    if (width && height) {
      return this.thumborizedImageUrlMap[`${imageUrl}&width=${width}&height=${height}`];
    }

    return this.thumborizedImageUrlMap[imageUrl];
  };
}
